const services = [
  {
    title: 'Enterprise Software',
    description: 'Custom enterprise solutions that streamline operations and drive business growth.',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    details: {
      features: [
        'Custom workflow automation',
        'Enterprise resource planning',
        'Business process management',
        'Legacy system modernization',
        'Integration with existing systems'
      ],
      benefits: [
        'Increased operational efficiency',
        'Reduced operational costs',
        'Improved data accuracy',
        'Enhanced decision-making',
        'Scalable architecture'
      ],
      technologies: ['Java', 'Spring Boot', '.NET', 'Node.js', 'React', 'Angular']
    }
  },
  {
    title: 'SaaS Platforms',
    description: 'Scalable cloud-based software solutions that adapt to your business needs.',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    ),
    details: {
      features: [
        'Multi-tenant architecture',
        'Subscription management',
        'Usage-based billing',
        'API-first approach',
        'Real-time analytics'
      ],
      benefits: [
        'Rapid deployment',
        'Pay-as-you-grow model',
        'Automatic updates',
        'Cross-platform compatibility',
        '24/7 availability'
      ],
      technologies: ['AWS', 'Azure', 'Docker', 'Kubernetes', 'React', 'Vue.js']
    }
  },
  {
    title: 'API Development',
    description: 'Robust and secure APIs that enable seamless integration and data exchange.',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    details: {
      features: [
        'RESTful API design',
        'GraphQL implementation',
        'API documentation',
        'Rate limiting',
        'Authentication & authorization'
      ],
      benefits: [
        'Improved system integration',
        'Enhanced security',
        'Better scalability',
        'Reduced development time',
        'Standardized communication'
      ],
      technologies: ['Node.js', 'Express', 'Swagger', 'PostgreSQL', 'MongoDB', 'Redis']
    }
  },
  {
    title: 'Cloud Infrastructure',
    description: 'Enterprise-grade cloud infrastructure designed for reliability and scalability.',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
    details: {
      features: [
        'Cloud migration',
        'Infrastructure as Code',
        'Auto-scaling',
        'Load balancing',
        'Disaster recovery'
      ],
      benefits: [
        'High availability',
        'Cost optimization',
        'Global reach',
        'Automated maintenance',
        'Enhanced security'
      ],
      technologies: ['AWS', 'Azure', 'Terraform', 'Kubernetes', 'Docker', 'Ansible']
    }
  },
  {
    title: 'Data Analytics',
    description: 'Advanced analytics solutions that transform data into actionable insights.',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    details: {
      features: [
        'Real-time analytics',
        'Predictive modeling',
        'Data visualization',
        'Business intelligence',
        'Custom reporting'
      ],
      benefits: [
        'Data-driven decisions',
        'Improved forecasting',
        'Better resource allocation',
        'Competitive advantage',
        'Enhanced customer insights'
      ],
      technologies: ['Python', 'R', 'TensorFlow', 'Tableau', 'Power BI', 'Apache Spark']
    }
  },
  {
    title: 'Security Solutions',
    description: 'Enterprise-grade security solutions to protect your digital assets and data.',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    details: {
      features: [
        'Threat detection',
        'Vulnerability assessment',
        'Security monitoring',
        'Compliance management',
        'Incident response'
      ],
      benefits: [
        'Enhanced data protection',
        'Regulatory compliance',
        'Reduced security risks',
        '24/7 monitoring',
        'Proactive defense'
      ],
      technologies: ['SIEM', 'WAF', 'IDS/IPS', 'Firewall', 'VPN', 'Zero Trust']
    }
  },
];

export default services; 